const ACTION_RE = /\{:([a-z-]+)\s+([^}]+)\}/g;

export function renderActions(el: HTMLElement) {
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  const texts: Text[] = [];
  while (walker.nextNode()) texts.push(walker.currentNode as Text);

  for (const node of texts) {
    const str = node.nodeValue ?? '';
    let modified = false;
    const frag = document.createDocumentFragment();
    let lastIndex = 0;

    for (const match of str.matchAll(ACTION_RE)) {
      const [full, action, text] = match;
      if (!action || !text) continue;
      const index = match.index ?? 0;
      const before = str.slice(lastIndex, index);
      if (before) frag.append(before);

      const a = document.createElement('a');
      a.href = '#';
      a.textContent = text;
      a.onclick = (e) => {
        e.preventDefault();
        window.dispatchEvent(
          new CustomEvent('messageaction', { detail: { action } })
        );
      };
      frag.append(a);
      modified = true;
      lastIndex = index + full.length;
    }

    const after = str.slice(lastIndex);
    if (after) frag.append(after);
    if (modified) node.replaceWith(frag);
  }
}

export type MessageAction = 'refresh';
export function handleMessageActions(handler: (action: MessageAction) => void) {
  return () => {
    const onAction = (e: Event) => {
      const action = (e as CustomEvent).detail.action;
      handler(action);
    };

    window.addEventListener('messageaction', onAction);
    return () => window.removeEventListener('messageaction', onAction);
  };
}

export function refresh(text: string) {
  return `{:refresh ${text}}`;
}
